import axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'usedFor',
    state: {
        usedFor: [],
    },
    getters: {
        getUsedFor: state => {
            return state.usedFor
        }
    },
    mutations: {
        SET_USEDFOR: (state, payload) => {
            state.usedFor = payload
        }
    },
    actions: {
        async FETCH_USEDFOR(store) {
            return await axios({
                method: "get",
                url: ServiceURL + "main/getUsedFor",
                params: {
                    tlc: store.rootState.user.auth.username
                },
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SET_USEDFOR', response.data.data)
            }).catch(err => {
                return err
            });
        },
    }
}